module.exports = __webpack_public_path__ + "app/modals/delete-user-modal.view.html";